module.exports = __webpack_public_path__ + "img/advice-3.daf8a3df.png";